/**
 * creditTypesAdmin.service.ts — Admin > Payments > Credit Types (legacy
 * Payment Credit Types): the account's names for patient credits, in the
 * account's order, through /credit-types. Writes need Admin Access.
 */
import { apiClient } from '@/services/apiClient';
import type { ApiResponse } from '@/types/api.types';

export interface AdminCreditType {
  id: number;
  name: string;
  active: boolean;
  order: number;
}

function toCreditType(raw: Record<string, unknown>): AdminCreditType {
  return {
    id: Number(raw.paymentsCreditTypeID) || 0,
    name: String(raw.name ?? ''),
    active: raw.active === true || raw.active === 1 || raw.active === '1',
    order: Number(raw.pctOrder) || 0,
  };
}

/** Every type, deleted ones too, in the account's order. */
export function listCreditTypes(): Promise<AdminCreditType[]> {
  return apiClient
    .get<ApiResponse<Record<string, unknown>[]>>('/credit-types')
    .then((r) => (r.data.data ?? []).map(toCreditType));
}

export function createCreditType(name: string): Promise<void> {
  return apiClient.post('/credit-types', { name: name.trim() }).then(() => undefined);
}

export function updateCreditType(id: number, name: string): Promise<void> {
  return apiClient.put(`/credit-types/${id}`, { name: name.trim() }).then(() => undefined);
}

export function deleteCreditType(id: number): Promise<void> {
  return apiClient.delete(`/credit-types/${id}`).then(() => undefined);
}

export function restoreCreditType(id: number): Promise<void> {
  return apiClient.post(`/credit-types/${id}/restore`).then(() => undefined);
}

/** The live types, in their new order. */
export function reorderCreditTypes(ids: number[]): Promise<void> {
  return apiClient.post('/credit-types/reorder', { ids }).then(() => undefined);
}
